import {useCallback} from 'react';

import {GridApi} from '../types/AgGridTypes';

export const useRedrawRows = (gridApi?: GridApi) =>
  useCallback(() => gridApi && gridApi.redrawRows(), [gridApi]);
